<build-section [title]="group.name" [disabled]="disabled">
  <form [formGroup]="yesNoForm">
    <div class="mb-3">
      <label class="radio-item radio-primary" [class.checked]="yesNoForm.get('yesNoResult').value === 0">
        <input type="radio" formControlName="yesNoResult" [value]="0" required/>
        <span>{{ 'common.no' | translate }}</span>
      </label>
    </div>
    <div class="mb-3">
      <label class="radio-item radio-primary" [class.checked]="yesNoForm.get('yesNoResult').value !== 0">
        <input type="radio" [value]="1" formControlName="yesNoResult" required/>
        <span>{{ yesOptionLabel }}</span>
      </label>
    </div>
  </form>
  <div class="help-text" *ngIf="group.helpText">
    {{ group.helpText }}
  </div>
</build-section>
